import { useSelector } from 'react-redux'
import { selectTemplateLabelMasterIds } from 'src/state/ducks/templates/selectors'
import { useQueryLabelMastersByIds } from '../api/useQueryLabelMastersByIds'

/**
 * ラベルマスタをid指定で取得する
 * 直接APIから取得するのではなく、useQueryLabelMastersByIdsにてキャッシュされたデータからフィルタして取得する
 */
export const useGetLabelMasterById = (id?: string) => {
  const allIds = useSelector(selectTemplateLabelMasterIds, compareFn)
  const { data: masters = [] } = useQueryLabelMastersByIds(allIds)
  return masters.find(m => m.id === id)
}

// selectorの同一性の比較関数、順序は比較しない
const compareFn = (prev: string[], next: string[]) => {
  if (prev.length !== next.length) return false
  const prevSet = new Set(prev)
  return next.every(id => prevSet.has(id))
}
